import React from 'react'
import { TypeAnimation } from 'react-type-animation'
import { useLanguage } from '../../contexts/LanguageContext'

const HomeMain = () => {
  const { t, currentLanguage } = useLanguage();
  return (
    <div id='website-responsive'>
    <div className='bg-img padding-main' style={{ backgroundImage:"url('/home/Header-image-2.webp')", height:'', width:'100%', }}>
        <div className=''>
            <h3 className='fs-ss-34 text-mulish text-white fw-500' style={{ letterSpacing:'1px'}}>
                {t('home.mainHeading')}
            </h3>
        </div>
        <div className='border-start border-5 mt-4'>
            {/* <span className='fs-ss-70 text-ss-primary text-philos'> */}
                <TypeAnimation 
                key={currentLanguage}
                sequence={[
                    t('home.typeAnimation.healthcareSolutions'),1000,
                    t('home.typeAnimation.graphicDesigning'),1000,
                    t('home.typeAnimation.webDevelopment'),1000,
                    t('home.typeAnimation.appDevelopment'),1000,
                    t('home.typeAnimation.seo'),1000,
                ]}
                wrapper="span"
                speed={1}
                deletionSpeed={1}
                className='fs-ss-70 textss-primary fw-800 text-philos ms-2 ms-md-4'
                style={{color:'#FE9B1F' }}
                repeat={Infinity}
                cursor={false} />
           
        </div>
    </div>
    </div>
  )
}

export default HomeMain